export default __webpack_public_path__ + "static/media/034-fast food.944ba5dc.svg";